import FeatureGates from '@atlaskit/feature-gate-js-client';

export const isTeamBiDirectionalEnabled = (fireExperimentExposure: boolean = false) => {
	if (FeatureGates.initializeCompleted()) {
		return FeatureGates.getExperimentValue(
			'team-bi-directional-container-connection',
			'isEnabled',
			false,
			{
				fireExperimentExposure,
			},
		);
	}

	return false;
};
